import React from 'react';

import {useUserContext} from "../../../contexts/UserContext";
import {CustomClientColumnHeader} from "../../CRM/ClientsPage/ClientsTableHeaders";

export const DealCRMClientsTableHeaders = () => {
    const { profileState } = useUserContext()
    const columns = profileState.client_columns

    const sortedColumns = Object.keys(columns).sort((a, b) => columns[a] - columns[b])

    return (
        <thead>
        <tr className={"clients_table_row"}>
            <th
                width={'2%'}
                key='Select All'
                className={'crm_table_header select'}
            >
            </th>
            <th
                width={'5%'}
                key='Name' className={'crm_table_header'}>
                Name
            </th>

            <th
                width={'3%'}
                key='Phone' className={'crm_table_header'}>
                Phone
            </th>
            <th
                width={'5%'}
                key='Email'
                className={'crm_table_header'}
            >
                Email
            </th>
            <th key='Vehicle'
                width={'15%'}
                className={'crm_table_header'}
            >
                Vehicle
            </th>
            <th
                width={'5%'}
                key='Profit'
                className={'crm_table_header'}
            >
                Profit
            </th>
            <th
                width={'4%'}
                key='Inception Date' className={'crm_table_header'}>
                Inception
            </th>
            <th
                width={'4%'}
                key='Maturity Date' className={'crm_table_header'}>
                Maturity
            </th>
            {
                sortedColumns.map((columnNum) => (
                        <CustomClientColumnHeader
                            key={columnNum}
                            column={columns[columnNum]}
                            columnNum={columnNum}/>
                    )
                )
            }

            <th key='Actions' width={'2%'} className={'crm_table_header'}>
                Actions
            </th>

        </tr>
        </thead>
    )
}